import React, { useState, useEffect } from 'react';
import SectionWidgetUnit from '../components/SectionWidgetUnit';
import Button from '../components/Button';
import '../styles/section-widget.css';
import { useTranslation } from 'react-i18next';
import TagList from '../components/TagList';

const SectionWidget = ({ sectionName, recentNine, url, forFrontPage, setDisplayMethod, displayMethod, defaultItemsShowed = 3 }) => {
    const { t } = useTranslation('sectionwidget');
    const [itemsShowed, setItemsShowed] = useState(defaultItemsShowed);
    const [sortList, setSortList] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [sortedFilteredNotes, setSortedFilteredNotes] = useState(recentNine);
    const [selectedTag, setSelectedTag] = useState(null); // Change to a single tag
    const [sortOption, setSortOption] = useState('newest'); // default sort option
    const tagList = TagList();

    const handleSort = (option) => {
        setSortOption(option);
        setSortList(false);
    };

    const handleTagFilter = (tag) => {
        setSelectedTag(tag === selectedTag ? null : tag);
    };

    useEffect(() => {
        let filtered = recentNine.filter(note =>
            (selectedTag === null || note.tags.includes(selectedTag)) &&
            (note.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
            note.description.toLowerCase().includes(searchQuery.toLowerCase()))
        );
        switch (sortOption) {
            case 'oldest': filtered.sort((a, b) => new Date(a.date) - new Date(b.date)); break;
            case 'newest': filtered.sort((a, b) => new Date(b.date) - new Date(a.date)); break;
            case 'popular-asc': filtered.sort((a, b) => a.views - b.views); break;
            case 'popular-desc': filtered.sort((a, b) => b.views - a.views); break;
            default: break;
        }
        setSortedFilteredNotes(filtered);
    }, [searchQuery, selectedTag, recentNine, sortOption]);

    return (
        <section className={`bl-${sectionName.toLowerCase().replace(/ /g, '-')} section-block`}>
            <div className="section-header">
                <h2 className="section-title">{sectionName}</h2>
                <div className="display-method-toggle">
                    {!forFrontPage && (
                        <input 
                            type="text" 
                            placeholder={t('input-search')} 
                            value={searchQuery} 
                            onChange={e => setSearchQuery(e.target.value)}
                            className="search-bar"
                        />
                    )}
                    {!forFrontPage && (
                        <Button onClick={() => setSortList(!sortList)} name={t('btn-sort')} className="btn-sort" />
                    )}
                    <div 
                        className={displayMethod ? "grid-view-button view-switcher-active" : "grid-view-button view-switcher-non-active"} 
                        onClick={() => setDisplayMethod(true)}
                    >
                        <img alt="button for display method grid" src='/icons/grid-view-button.svg' />
                    </div>
                    <div 
                        className={!displayMethod ? "list-view-button view-switcher-active" : "list-view-button view-switcher-non-active"} 
                        onClick={() => setDisplayMethod(false)}
                    >
                        <img alt="button for display method list" src='/icons/list-view-button.svg' />
                    </div>
                </div>
            </div>
            {sortList && (
                <div className="sort-options">
                    <button onClick={() => handleSort('oldest')}>{t('sort.oldest')}</button>
                    <button onClick={() => handleSort('newest')}>{t('sort.newest')}</button>
                    <button onClick={() => handleSort('popular-asc')}>{t('sort.popular-asc')}</button>
                    <button onClick={() => handleSort('popular-desc')}>{t('sort.popular-desc')}</button>
                </div>
            )}
            {!forFrontPage && (
                <div className="tag-filter">
                    {recentNine.flatMap(note => note.tags).filter((tag, index, self) => self.indexOf(tag) === index).map(tag => (
                        <div key={tag} className={selectedTag === tag ? 'tag-filter-option button active' : 'tag-filter-option button'} onClick={() => handleTagFilter(tag)}>
                            <div
                                key={tag}
                                className={"section-unit-tag section-unit-tag-" + tagList[tag].name}
                                style={{ backgroundColor: tagList[tag].color }}
                            >
                                {tagList[tag].name}
                            </div>
                        </div>
                    ))}
                </div>
            )}
            <div className={displayMethod ? "units-container grid-style" : "units-container list-style"}>
                {sortedFilteredNotes.length > 0 ? (
                    sortedFilteredNotes.slice(0, itemsShowed).map((unit, index) => (
                        <SectionWidgetUnit 
                            key={index} 
                            list={displayMethod} 
                            num={unit.num}
                            title={unit.title} 
                            description={unit.description} 
                            url={unit.url}
                            date={unit.date}
                            tags={unit.tags}
                        />
                    ))
                ) : (
                    <div className="no-results-found">{t('No results found')}</div>
                )}
                <div className="filling-empty-space-childs"></div>
                <div className="filling-empty-space-childs"></div>
            </div>
            <div className="section-footer">
                {sortedFilteredNotes.length > 3 && (
                    <Button onClick={() => setItemsShowed(itemsShowed === 3 ? sortedFilteredNotes.length : 3)} name={(itemsShowed === 3) ? t('btn-more') : t('btn-less')} className="show-content" />
                )}
                <Button url={url} name={t('btn-all')} className="see-all" />
            </div>
        </section>
    );
};

export default SectionWidget;
